// import PropTypes from "prop-types";
import { DownOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

import { useState } from 'react';

import { Dropdown, Input, Checkbox, Button, Typography, Divider, DatePicker, Select } from 'antd';

import FilterDateSelector from './FilterDateSelector';
import FilterSearch from './FilterSearch';
import { GetSearchWidth } from '../../clientUtils';
import * as Constants from '../../constants';

const { Search } = Input;
const { RangePicker } = DatePicker;

export const Filters = ({ data, selectedValues, onFilterApply, query }) => {
  const [searchInput, setSearchInput] = useState('');
  const type = data?.type;
  if (type === 'filterSearch') {
    return <FilterSearch id={data?.field} onFilterApply={onFilterApply} options={data?.options} />;
  }
  if (type === 'filterDate') {
    return (
      <FilterDateSelector
        futureType={['expected_delivery_date', 'approved_delivery_date', 'expected_dispatch_date', 'dispatch_date']}
        id={data?.field}
        onFilterApply={onFilterApply}
        options={data?.options}
        presets={presets}
      />
    );
  }
  if (type === 'options') {
    if (!data.multiselect) {
      return <SelectWrapper data={data} onFilterApply={onFilterApply} value={selectedValues} />;
    }
    return (
      <CustomDropDown key={data?.field} data={data} onFilterApply={onFilterApply} selectedValues={selectedValues} />
    );
  }
  if (type === 'input') {
    return (
      <Search
        key={data?.field}
        onChange={(e) => setSearchInput(e.target.value)}
        onSearch={(value) => {
          if (!value || value.trim() === '') return;
          onFilterApply(type, data?.field, value);
          setSearchInput('');
        }}
        placeholder={data?.label}
        style={{ minWidth: 100, width: GetSearchWidth(data?.field) }}
        value={searchInput}
      />
    );
  }
  if (type === 'date_range') {
    // returns a date selector
    // default dates back to last 1 month
    // return <Input placeholder={data?.label}></Input>;
    const handleDateRangeChange = (dates) => {
      if (!dates) {
        onFilterApply(type, data?.field, [undefined, undefined]);
        return;
      }
      if (dates.some((date) => !date)) return;
      onFilterApply(type, data?.field, [dates[0]?.toISOString(), dates[1]?.toISOString()]);
    };
    return (
      // <CustomDateRange
      //   dates={{
      //     start_date: selectedValues?.start_date,
      //     end_date: selectedValues?.end_date,
      //   }}
      //   onApply={handleDateRangeChange}
      //   options={data?.options}
      // />
      <RangePicker
        allowEmpty={[true, true]}
        format={Constants.DATE_FORMAT}
        onChange={handleDateRangeChange}
        presets={presets}
        style={{ width: 220 }}
        value={[
          selectedValues?.start_date && dayjs(selectedValues?.start_date),
          selectedValues?.start_date && dayjs(selectedValues?.end_date)
        ]}
        disabledDate={(current) => current && current > dayjs().endOf('day')}
        // format={() =>
        //   getLabel([
        //     dayjs(selectedValues?.start_date),
        //     dayjs(selectedValues?.end_date),
        //   ])
        // }
      >
        {/* <Button>
          {getLabel([
            dayjs(selectedValues?.start_date),
            dayjs(selectedValues?.end_date),
          ])}
        </Button> */}
      </RangePicker>
    );
  }
};

const presets = [
  { label: 'Last 1 Month', value: [dayjs().add(-1, 'M'), dayjs()] },
  { label: 'Last 6 Months', value: [dayjs().add(-6, 'M'), dayjs()] },
  { label: 'Year Till Date', value: [dayjs().add(-1, 'y'), dayjs()] }
];

const CustomDropDown = ({ data, selectedValues, onFilterApply }) => {
  const [open, setOpen] = useState(false);
  const handleOpenChange = (flag) => {
    setOpen(flag);
  };
  const onCancel = () => {
    setOpen(false);
  };
  return (
    <Dropdown
      destroyPopupOnHide
      dropdownRender={() => (
        <MultiSelect data={data} onApply={onFilterApply} onCancel={onCancel} selectedValues={selectedValues} />
      )}
      onOpenChange={handleOpenChange}
      open={open}
      trigger={['click']}
    >
      <Button>
        {data.label}
        <DownOutlined />
      </Button>
    </Dropdown>
  );
};

const transformOptions = (options, selectedValues) => {
  const selectedSet = new Set();
  for (let i = 0; i < selectedValues?.length; i++) {
    selectedSet.add(selectedValues[i].id);
  }
  return options?.map((opt) => ({
    ...opt,
    label: opt.name,
    value: opt.id,
    selected: selectedSet.has(opt.id)
  }));
};

const MultiSelect = ({ data, selectedValues, onCancel, onApply }) => {
  const [options, setOptions] = useState(transformOptions(data?.values, selectedValues));
  const clearAll = () => {
    const newState = options.map((element) => ({
      ...element,
      selected: false
    }));
    setOptions(newState);
  };

  const handleSelect = (e, id) => {
    e.stopPropagation();
    const newState = options.map((element) =>
      element.id === id ? { ...element, selected: e.target.checked } : element
    );
    setOptions(newState);
  };

  const applyFilter = () => {
    // extract selected filters
    // data.field = [ids]
    const filtered = options.filter((o) => o?.selected);
    const newFilters = filtered.map((o) => ({ id: o.id, label: o.name }));
    onApply(data?.type, data?.field, newFilters && newFilters.length > 0 ? newFilters : undefined);
    onCancel();
    // setQuery({
    //   ...query,
    //   [GetRequestMapping(data.field)]:
    //     newFilters.length === 0 ? undefined : newFilters,
    // });
    // setOpen(false);
  };

  return (
    <div className="dropdown-card">
      <div className="body">
        <section className="search">{/* <Search placeholder="Search" onSearch={() => {}} /> */}</section>
        <section className="summary">
          <Typography.Text>
            <strong>Selected ({options.filter((option) => option.selected === true).length}) </strong>
          </Typography.Text>
          <Button onClick={clearAll} type="link">
            Clear All
          </Button>
        </section>
        <section className="group_checkbox selected">
          {options
            .filter((option) => option.selected)
            .map((o) => (
              <Checkbox key={o.id} checked={o?.selected} onChange={(e) => handleSelect(e, o.id)}>
                {o.label}
              </Checkbox>
            ))}
        </section>
        <section className="title">
          <Divider />
          <Typography.Title level={5}>{data.label}</Typography.Title>
        </section>
        <section className="group_checkbox options">
          {options
            .filter((option) => !option.selected)
            .map((o) => (
              <Checkbox key={o?.id} checked={o?.selected} onChange={(e) => handleSelect(e, o.id)}>
                {o.label}
              </Checkbox>
            ))}
        </section>
      </div>
      <section className="footer">
        <Button onClick={onCancel}>Cancel</Button>
        <Button onClick={applyFilter} type="primary">
          Apply
        </Button>
      </section>
    </div>
  );
};

const SelectWrapper = ({ data, value, onFilterApply }) => {
  const getOptions = () => data?.values?.map((opt) => ({ label: opt.name, value: opt.id })) ?? [];

  const applyFilter = (value) => {
    onFilterApply(data?.type, data?.field, [{ id: value, label: data.values?.find((i) => i.id === value).name }]);
  };
  return (
    <Select
      onChange={applyFilter}
      options={getOptions()}
      placeholder={data?.label}
      popupMatchSelectWidth={false}
      style={{ minWidth: 140 }}
      styles={{ popup: { minWidth: 220 } }}
      value={value}
    />
  );
};
